import React, { createContext, useContext, useState, useCallback } from 'react';

const ModalContext = createContext();

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};

export const ModalProvider = ({ children }) => {
    const [modal, setModal] = useState({ type: null, props: {} });

    const openAlert = useCallback((message, title = "알림", onOk) => {
        setModal({ type: 'alert', props: { message, title, onOk } });
    }, []);

    const openConfirm = useCallback((title, message, onConfirm, onCancel, options = {}) => {
        setModal({ type: 'confirm', props: { title, message, onConfirm, onCancel, ...options } });
    }, []);

    const openPrompt = useCallback((message, title = "입력", defaultValue = "", onSubmit, onCancel) => {
        setModal({ type: 'prompt', props: { message, title, defaultValue, onSubmit, onCancel } });
    }, []);

    const openModal = useCallback((modalData) => {
        setModal(modalData);
    }, []);

    const closeModal = useCallback(() => {
        setModal({ type: null, props: {} });
    }, []);

    return (
        <ModalContext.Provider value={{ modal, openAlert, openConfirm, openPrompt, openModal, closeModal }}>
            {children}
        </ModalContext.Provider>
    );
};
